import StringMask from 'string-mask';

export function retornaCpfCnpjFormatado(cpfCnpj: string) {
  if (cpfCnpj?.length <= 11) {
    const formatter = new StringMask('000.000.000-00');
    return formatter.apply(cpfCnpj);
  }

  const formatter = new StringMask('00.000.000/0000-00');
  return formatter.apply(cpfCnpj);
}

export function retornaCEPFormatado(cep: string) {
  const formatter = new StringMask('00000-000');
  return formatter.apply(cep);
}


export function numberToReal(numero: any) {
  numero = typeof numero === 'string' ? parseFloat(numero) : numero;
  numero = numero.toFixed(2).split('.');
  numero[0] = numero[0].split(/(?=(?:...)*$)/).join('.');
  return numero.join(',');
}

export function codigoBarra(codigo: string) {
  const formatter = new StringMask('00000.00000 00000.000000 00000.000000 0 000000000000000');
  return formatter.apply(codigo);
}

export default {
  numberToReal,
  retornaCEPFormatado,
  retornaCpfCnpjFormatado,
  codigoBarra,
};
